"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledArrowIcon = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const ArrowIconRotationValues_1 = require("./helpers/ArrowIconRotationValues");
const ArrowIconSize_1 = require("./helpers/ArrowIconSize");
exports.StyledArrowIcon = styled_components_1.default.svg `
    min-width: ${ArrowIconSize_1.ARROW_ICON_SIZE.width}px;
    max-width: ${ArrowIconSize_1.ARROW_ICON_SIZE.width}px;

    min-height: ${ArrowIconSize_1.ARROW_ICON_SIZE.height}px;
    max-height: ${ArrowIconSize_1.ARROW_ICON_SIZE.height}px;

    margin: auto;

    ${({ disabled, error, color, theme }) => {
    if (disabled) {
        return (0, styled_components_1.css) `
                fill: ${theme.colorControlIconDisabled};
            `;
    }
    if (error) {
        return (0, styled_components_1.css) `
                fill: ${theme === null || theme === void 0 ? void 0 : theme.colorControlIconError};
            `;
    }
    return (0, styled_components_1.css) `
            fill: ${color || theme.colorControlIcon}};
        `;
}}

    ${({ direction }) => direction &&
    (0, styled_components_1.css) `
            transform: rotate(${ArrowIconRotationValues_1.ARROW_ICON_ROTATION_VALUES[direction]});
        `}
`;
//# sourceMappingURL=ArrowIcon.styles.js.map